import { TextField } from '@mui/material';
import { styled } from '@mui/system';

const TextFieldReadAble = styled(TextField)({
    input: {
        color: 'grey',
        fontWeight: 'bold',
    }
})
export default TextFieldReadAble;